
import React, { useState } from "react";
import {
  Container,
  InputLabel,
  Box,
  FormControl,
  Select,
  MenuItem,
  AlertTitle,
  Alert,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fileReportDownload } from "../../../utils/fileReportDownload";
import { dateToFormat } from "../../../utils/dateParsing";
import { INSURER_LIST_NEW } from "../../../utils/constants/insurerList";
import es from "date-fns/locale/es";

const REPORTS_TYPE = [
  { name: 'Facturacion', url: '/bomberos_envigado/billing_export', file: 'facturacion' },
  { name: 'Insumos', url: '/bomberos_envigado/supplies_export', file: 'insumos' },
  { name: 'Furtran', url: '/bomberos_envigado/furtran_export', file: 'furtran', showInsurerListField: true },
  { name: 'Furtran (txt)', url: '/bomberos_envigado/furtran_export_txt', file: 'furtran-txt', extension: '.txt', showInsurerListField: true },
  { name: 'Furips', url: '/bomberos_envigado/furips_export', file: 'Furips', extension: '.zip', formatFile: 'xls' },
  { name: 'Furips (txt)', url: '/bomberos_envigado/furips_export', file: 'Furips-txt', extension: '.zip', formatFile: 'txt' },
  { name: 'RIPs (JSON)', url: '/bomberos_envigado/rips_export_json', file: 'RIPs-JSON', extension: '.json', showIdentificationField: true },
  { name: 'RIPs', url: '/bomberos_envigado/rips_2275_export', file: 'RIPs' },
];

export const BomberosEnvigadoBilling = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [filterType, setFilterType] = useState(REPORTS_TYPE[0]);
  const [insurerSelected, setInsurerSelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});

  registerLocale("es", es);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    requestReport(data);
  };

  const requestReport = async (data) => {
    try {
      const identification = data ? data.get("identification") : '';
      const params = {
        fromDate: dateToFormat(fromDate, 'YYYY/MM/DD HH:mm'),
        untilDate: dateToFormat(toDate, 'YYYY/MM/DD HH:mm'),
        formatFile: filterType.formatFile,
        insurerCode:insurerSelected.code
      }
      if (identification) {
        params.patientIdentification = identification;
      }
      setShowAlert(false);
      setLoading(true);
      const extention = filterType.isPDF ? '.pdf' : '.xlsx'
      await fileReportDownload(filterType.url, params, `${filterType.file}${filterType.extension || extention}`, filterType.isPDF);
      setLoading(false);
    } catch (error) {
      console.log("error -> ", error);
      if (error.response.status === 406) { //range bad
        setAlertInfo({
          title: "Error",
          message: "Rango de fecha excedido",
          action: "Cambia el rango de fechas",
        });
        setShowAlert(true);
      } else if (error.response.status === 400) { // rango no válido
        setAlertInfo({
          title: "Error",
          message: "El rango de fecha no es válido",
          action: "Valida que el rango sea correcto",
        });
        setShowAlert(true);
      } else if (error.response.status === 0) {
        setAlertInfo({
          title: "Timeout",
          message: "Ocurrio un error procesando",
          action: "Intenta reduciendo el rango de fechas",
        });
        setShowAlert(true);
      } else {
        setAlertInfo({
          title: "Error del servidor",
          message: "Ocurrio un error procesando",
          action: "Intenta reduciendo el rango de fechas",
        });
        setShowAlert(true);
      }
      setLoading(false);
    }
  };

  const handleChangeSelect = (event) => {
    event.preventDefault();
    setFilterType(event.target.value);
  };

  const handleChangeInsurerSelect = (event) => {
    event.preventDefault();
    setInsurerSelected(event.target.value)
  };


  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          {showAlert && (
            <Alert onClose={() => setShowAlert(false)} severity="error">
              <AlertTitle>{alertInfo?.title}</AlertTitle>
              {alertInfo?.message} — <strong>{alertInfo?.action}</strong>
            </Alert>
          )}

          <InputLabel>Desde</InputLabel>
          <div style={{ display: "flex", marginBottom: 10 }}>
            <DatePicker
              dateFormat="yyyy/MM/dd HH:mm"
              selected={fromDate}
              onChange={setFromDate}
              showTimeSelect
              name="fromDate"
              locale="es"
              className="react-datetimepicker-custom"
            />
          </div>

          <InputLabel>Hasta</InputLabel>
          <div style={{ display: "flex" }}>
            <DatePicker
              dateFormat="yyyy/MM/dd HH:mm"
              selected={toDate}
              onChange={setToDate}
              showTimeSelect
              name="toDate"
              locale="es"
              className="react-datetimepicker-custom"
            />
          </div>

          <br />
          <FormControl fullWidth>
            <InputLabel id="filtertype-select-label">Filtrar Por</InputLabel>
            <Select
              labelId="filtertype-select-label"
              id="filtertype-select"
              value={filterType}
              label="filterType"
              onChange={handleChangeSelect}
              name="filtertype-select"
            >
              {
                REPORTS_TYPE.map((item, key) => <MenuItem value={item}>{item.name}</MenuItem>)
              }
            </Select>
          </FormControl>

          {
            filterType.showIdentificationField ?
              <>
                <br />
                <br />
                <FormControl fullWidth>
                  <TextField
                    margin="normal"
                    fullWidth
                    id="identification"
                    label="Identificación"
                    name="identification"
                    autoComplete="identification"
                    autoFocus
                  />
                </FormControl>
              </>
              : null
          }

          {
            filterType.showInsurerListField ?
              <>
                <br />
                <br />
                <FormControl fullWidth>
                  <InputLabel id="filtertype-ambulance-label">Seleccione la aseguradora</InputLabel>
                  <Select
                    labelId="filtertype-insurer-label"
                    id="filtertype-insurer"
                    value={insurerSelected}
                    label="Seleccione la aseguradora"
                    onChange={handleChangeInsurerSelect}
                    name="filtertype-insurer"
                  >
                    {
                      INSURER_LIST_NEW.map((item, key) =>
                        <MenuItem key={key + item.name} value={item}>
                          {item.name}
                        </MenuItem>)
                    }
                  </Select>
                </FormControl>
              </>
              : null
          }


          <LoadingButton
            type="submit"
            fullWidth
            loading={loading}
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Generar Reporte
          </LoadingButton>
        </Box>
      </Box>
    </Container>
  );
};
